import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class ModuleVideo extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path d="M6.6,11l-0.5-0.2V5.1l0.5-0.2l4.2,2.8v0.5L6.6,11z M6.8,5.7v4.5l3.4-2.2L6.8,5.7z" />
          <path d="M15.4,13.7H0.6l-0.3-0.3V2.6l0.3-0.3h14.9l0.3,0.3v10.9L15.4,13.7z M0.9,13.1h14.3V2.9H0.9V13.1z" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ModuleVideo.js